























































































import Vue from "vue";
import NavigationButtonFooter from "@/components/navigation-button-footer/NavigationButtonFooter.vue";

export default Vue.extend({
  name: "Footer",
  components: {
    NavigationButtonFooter
  },
  data() {
    return {
      year: "2020"
    };
  },
  mounted() {
    this.year = this.getCurrentYear();
  },
  methods: {
    getCurrentYear() {
      const date = new Date().getFullYear();

      if (typeof date !== "number" || isNaN(date)) return this.year;

      return date.toString();
    }
  }
});
